// data/entertainment.js

export const entertainmentItems = [
  {
    id: "luck",
    name: "근육고양이 운세톡",
    description: "사용자의 카카오톡으로 매일 아침 운세를 보내주는 서비스입니다.", // (projects.js의 shortDescription)
    imageUrl: "/images/luck-title.png", // (projects.js의 imageUrl)
    link: "https://musclecat-studio.com/luck", // (projects.js의 serviceUrl)
  },
  {
    id: "toon",
    name: "근육고양이 만화책",
    description: "근육고양이 스튜디오의 근간이 된 김냐냐씨의 만화 보기 서비스입니다.", // (projects.js의 shortDescription)
    imageUrl: "/images/toon-title.png", // (projects.js의 imageUrl)
    link: "https://musclecat-toon.com", // (projects.js의 serviceUrl)
  },
  {
    id: "drawing",
    name: "근육고양이 낙서판",
    description: "근육고양이잡화점의 방명록으로 사용되는 낙서판이다!", // (projects.js의 shortDescription)
    imageUrl: "/images/drawing-title.jpg", // (projects.js의 imageUrl)
    link: "https://musclecat-drawing.vercel.app/", // (projects.js의 serviceUrl)
  },
  {
    id: "playlist",
    name: "근육고양이 플레이리스트",
    description: "근육고양이잡화점 매장의 배경음악 플레이리스트이다!", // (projects.js의 shortDescription)
    imageUrl: "/images/playlist-title.png", // (projects.js의 imageUrl)
    link: "https://musclecat-playlist.vercel.app/", // (projects.js의 serviceUrl)
  },
  {
    id: "catsurvival",
    name: "길냥이 서바이벌",
    description: "벌판의 들개들로부터 살아 남자! 뱀서류 길고양이 게임입니다.", // (projects.js의 shortDescription)
    imageUrl: "/images/catsurvival-title.png",
    link: "https://cat-survival-lite.vercel.app/",
  },
  {
    id: "wallballshot",
    name: "월볼샷 게임",
    description: "월볼샷이 얼마나 개열받는 운동인지 게임을 통해 체험해보자!", // (projects.js의 shortDescription)
    imageUrl: "/images/wallball-title.png", // (projects.js의 imageUrl)
    link: "https://musclecat.co.kr/wallball", // (projects.js의 serviceUrl)
  }
];